import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { PASSWORD_CHANGE_REQUIRED_ACCOUNTS } from '@/common/const';

// 비밀번호는 저장하지 않고, 변경이 필요한 계정만 브라우저에 보관한다.
const accountsAtom = atomWithStorage<string[]>(PASSWORD_CHANGE_REQUIRED_ACCOUNTS, [], undefined, { getOnInit: true });

const normalizeIdentifier = (identifier: string) => identifier.trim().toLowerCase();

export const usePasswordChangeRequired = (identifier?: string) => {
  const [accounts, setAccounts] = useAtom(accountsAtom);

  const setRequired = (identifier: string, required: boolean) => {
    const account = normalizeIdentifier(identifier);
    setAccounts((previous) => {
      const remaining = Array.isArray(previous) ? previous.filter((value) => value !== account) : [];
      return required ? [...remaining, account] : remaining;
    });
  };

  return {
    is_required: !!identifier && Array.isArray(accounts) && accounts.includes(normalizeIdentifier(identifier)),
    setRequired,
  };
};
